import { Col, Form, Input, Modal, Row, Select, message } from 'antd';
import React, { useEffect } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import { debounce } from 'lodash';

const MultiDropdown = ({
  name,
  controlWidth,
  source,
  options,
  bg,
  onChange,
  multiSelect,
  searchable,
  onChangeConfMsg,
  isCache,
  cacheId,
  defaultValue,
  required,
  includeAll,
  errorMessage,
  disabled,
  controlsNo,
  label,
  placeholder,
  url,
  urlData,
  pname,
  extraData,
  form,
  maxLength
}) => {

  const [loading, setLoading] = React.useState(false);
  const [dropOptions, setDropOptions] = React.useState([]);
  const [inverseDropOptions, setInverseDropOptions] = React.useState([]);
  const [dropSearch, setDropSearch] = React.useState({});
  const [loginError, setLoginError] = React.useState(false);

  useEffect(() => {
    form.setFieldValue(name, defaultValue);
  }, []);

  const isRequired = (index) => {
    if (typeof (required) === 'boolean') {
      return required;
    };
    if (typeof (required) === 'object') {
      return required[index]
    }
  }

  React.useEffect(() => {
    setLoading(true);
    // console.log(name, pname);
    let IterOptions;
    if (source !== "dynamic") {
      IterOptions = fetchLocalData();
    };

    if (isCache && cacheId) {
      IterOptions = fetchLocalData(cacheId);
    };

    // console.log(IterOptions);
    if (IterOptions && Object.keys(IterOptions).length > 0) {
      parseData(IterOptions);
    } else {
      fetchApiData();
    }
    setLoading(false);
  }, [cacheId, label]);

  const onSelectChange = () => {
    let pVal = [];
    let val = form.getFieldValue(pname);
    val.forEach(x => {
      if (x === 'all') {
        pVal.push('All');
      } else {
        pVal.push(getIdFromName(x));
      }
    });
    form.setFieldValue(name, pVal);
    // if (multiSelect) {
    //   let idArray = [];
    //   if (includeAll) {
    //     idArray.push("all");
    //   }

    //   value.forEach((element, index) => {
    //     idArray.push(getIdFromName(element));
    //   });
    //   form.setFieldsValue({ [`${name}`]: idArray });
    // } else {
    //   if (value === "all") {
    //     form.setFieldsValue({
    //       [`${name}`]: value,
    //     });
    //     form.setFieldsValue({
    //       [`${pname}`]: "All",
    //     });
    //   } else {
    //     form.setFieldsValue({
    //       [`${name}`]: labelAsVal ? value : getIdFromName(value),
    //     });
    //   }
    // }
  }

  const onSearch = debounce((val) => {
    setLoading(true);
    liracrypt.get(url, { ...extraData, ...urlData, search: val })
      .then(response => {
        setLoading(false);
        console.log(response);
      }).catch(err => {
        setLoading(false);
        message.error('Something went wrong');
        console.log(err);
      })
  }, 500);

  const getIdFromName = (name) => {
    return name ? dropSearch[name] : null;
  };

  const onChangeConfirmation = (value) => {
    if (!onChangeConfMsg) return;
    if (value === defaultValue) return;
    Modal.confirm({
      title: onChangeConfMsg.text,
      okText: onChangeConfMsg.okButtonLabel,
      cancelText: onChangeConfMsg.cancelButtonLabel,
      cancelButtonProps: { danger: true, type: 'primary' },
      // okButtonProps: {  },
      onOk: () => { onSelectChange(value) },
      onCancel: () => {
        form.setFieldsValue({ [name]: defaultValue });
        form.setFieldsValue({ [`${pname}`]: getIdFromName(defaultValue) });
      }
    });
  }

  function getCacheData(key) {
    let __key = `cache_dropdown_${key}`;
    const itemStr = localStorage.getItem(__key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    return item.value.data ? item.value.data : item.value;
  }

  const setCacheData = (key, value) => {
    let __key = `cache_dropdown_${key}`;
    const now = new Date();
    const item = {
      value: { data: value },
      expiry: now.getTime() + 600000,
    };
    localStorage.setItem(__key, JSON.stringify(item));
  }

  const parseData = (IterOptions) => {
    let optionList = [];
    let inverseList = {};
    let drop = {};
    if (!IterOptions) {
      setDropOptions(null);
      setInverseDropOptions(null);
      setDropSearch(null);
      return;
    }
    if (includeAll) {
      optionList.push({ label: "All", value: "all" });
      inverseList["all"] = "All";
      drop["All"] = "all";
    }
    Object.keys(IterOptions).forEach((value, index) => {
      // optionList.push({ label: IterOptions[value], value: value });
      optionList.push({ label: IterOptions[value], value: IterOptions[value] });
      inverseList[value] = IterOptions[value];

      drop[IterOptions[value]] = value;
    });

    if (defaultValue?.length) {
      let defaultPNameValue = [];
      defaultValue.forEach(x => {
        defaultPNameValue.push(inverseList[x]);
      });
      form.setFieldValue(pname, defaultPNameValue);
    }

    setDropOptions(optionList);
    setInverseDropOptions(inverseList);
    setDropSearch(drop);
  };

  const fetchApiData = () => {
    // console.log("UNI Fetch");
    if (url) {
      liracrypt
        .get(url, { ...extraData, ...urlData })
        .then((res, req) => {
          if (cacheId) {
            setCacheData(
              cacheId,
              res.data.data.data ? res.data.data.data : res.data.data
            );
          } else {
            if (source === "mdict") {
              setCacheData(
                urlData["typ"] + "_" + urlData["subTyp"],
                res.data.data.data ? res.data.data.data : res.data.data
              );
            } else {
              setCacheData(
                urlData["name"],
                res.data.data.data ? res.data.data.data : res.data.data
              );
            }
          }

          parseData(res.data.data.data ? res.data.data.data : res.data.data);
        })
        .catch((err) => {
          console.log(err, 'error')
          parseData(null);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              // ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    };
  };

  const fetchLocalData = (id) => {
    let IterOptions = {};
    if (options) {
      IterOptions = options;
    } else {
      let localData;
      if (id) {
        localData = getCacheData(id);
      } else {
        if (source === "mdict") {
          localData = getCacheData(urlData["typ"] + "_" + urlData["subTyp"]);
        } else {
          localData = getCacheData(urlData["name"]);
        }
      }

      // console.log(localData);
      if (localData) {
        IterOptions = localData;
      }
    }
    return IterOptions;
  };


  return (
    <>
      <Row>
        <Col span={24} className='ant-form-item-label ant-form-item-label-wrap' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
          <label className={`${required ? 'ant-form-item-required' : ''} ant-form-item-no-colon`} title={label}>{label}</label>
        </Col>
      </Row>

      <div style={{ display: 'inline-flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
        {
          Array.from({ length: controlsNo }).map((_, idx) => (
            <>
              <Form.Item
                // initialValue={defaultValue}
                name={[name, idx]}
                hidden
              >
                <Input />
              </Form.Item>

              <Form.Item
                //    label={label}
                style={{ width: controlWidth[idx] }}
                key={pname + "input" + idx}
                name={[pname, idx]}
                //    initialValue={defaultValue ? defaultValue[idx] : null}
                rules={[
                  { required: isRequired(idx), message: errorMessage }
                ]}
              >
                <Select
                  allowClear={false}
                  onSearch={source === 'dynamicSearch' ? onSearch : undefined}
                  style={{ background: bg, minHeight: 40 }}
                  loading={loading}
                  showSearch={searchable ? searchable : false}
                  onChange={(value) => {
                    if (onChangeConfMsg) {
                      onChangeConfirmation(value);
                    } else {
                      onSelectChange({ value, idx });
                    }
                    if (onChange) {
                      onChange(value, getIdFromName(value));
                    }
                  }}
                  //  defaultValue={defaultValue}
                  placeholder={placeholder}
                  defaultActiveFirstOption={true}
                  disabled={disabled}
                  mode={multiSelect ? "multiple" : ""}
                  options={dropOptions}
                />
              </Form.Item>
            </>
          ))
        }
      </div>
    </>
  )
};

export default MultiDropdown;